import { X, Save } from "lucide-react";

export const SimpleModal = ({ title, onClose, onSave, children, saveLabel = "Enregistrer" }) => (
  <div className="fixed inset-0 z-50 bg-black/40 flex items-stretch md:items-center justify-center p-0 md:p-6">
    <div className="bg-white w-full md:max-w-2xl md:max-h-[90vh] overflow-auto md:rounded-md">
      <div className="sticky top-0 bg-white border-b border-[var(--lc-border)] px-5 py-3 flex items-center justify-between z-10">
        <div className="font-bold">{title}</div>
        <button onClick={onClose} data-testid="modal-close" className="p-2 hover:bg-black/5 rounded"><X className="w-4 h-4" /></button>
      </div>
      <div className="p-5">{children}</div>
      <div className="sticky bottom-0 bg-white border-t border-[var(--lc-border)] px-5 py-3 flex justify-end gap-2">
        <button onClick={onClose} className="lc-btn-secondary">Annuler</button>
        <button onClick={onSave} data-testid="modal-save" className="lc-btn-primary inline-flex items-center gap-2"><Save className="w-4 h-4" />{saveLabel}</button>
      </div>
    </div>
  </div>
);
